import React from "react";

const FilterTitle = ({ title = "Basic Filters" }) => {
    return (
        <div className="d-flex justify-content-between align-items-center mb-3">
            {title}
            <i className="bi bi-chevron-up"></i>
        </div>
    );
};

export default FilterTitle;